module.exports = __webpack_public_path__ + "media/images/cleaning/pro1@2x-686f650320a9cfb947b2f04a49eccea7.jpg";